/* eslint-disable @typescript-eslint/no-unused-vars */
import testAssets from "@ui5/webcomponents/dist/bundle.esm.js";

// AI assets
import "./Assets.js";

import Button from "./Button.js";
import ButtonState from "./ButtonState.js";
import PromptInput from "./PromptInput.js";
import TextArea from "./TextArea.js";
import Input from "./Input.js";

export default testAssets;
